export default {
	primary: '#ff6f61',
}


// WEBPACK FOOTER //
// ./src/themes/lightredTheme.js